import React, { Component } from "react";
import ServicesHeader from "../elements/services-header";

// Elements
import Help from "../elements/help";
import ServiceFeaturesSection from "../elements/feature-bx-service";

class CarService extends Component {
  render() {
    return (
      <>
        <ServicesHeader title="Service" />;
        <div className="section-area section-sp1">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 col-md-5">
                <ServiceFeaturesSection />
              </div>
              <div className="col-lg-4 col-md-5">
                <aside className="sticky-top pb-1">
                  <Help></Help>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CarService;
